<template>
  <v-dialog :value="isModalOpen" persistent width="480">
    <modal-card :title="title" full padding :closable="false">
      <p class="pl-2 pt-2">
        <template v-if="isBanned">
          You have been banned from this interview.
        </template>
        <template v-else> Thank you! </template>
      </p>
    </modal-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'EndInterviewWarning',
  computed: {
    ...mapState('rooms', ['finishedInterviewInfo', 'roomInfo']),
    ...mapGetters('rooms', ['interviewFinished']),
    title() {
      return this.isBanned ? 'Access Denied' : 'Interview Finished';
    },

    isModalOpen() {
      return this.interviewFinished;
    },

    isBanned() {
      return this.finishedInterviewInfo?.reason === 'ban';
    },
  },
  methods: {
    ...mapMutations('rooms', ['extractFinishedInterviewInfo']),

    // check interview status after user returns from breakout room
    visibilityChanged() {
      const isVisible = document.visibilityState === 'visible';
      if (isVisible) {
        this.extractFinishedInterviewInfo();
      }
    },

    toggleVisibilityListener(add) {
      const method = add ? 'addEventListener' : 'removeEventListener';
      document[method]('visibilitychange', this.visibilityChanged);
    },
  },
  created() {
    this.extractFinishedInterviewInfo();
    this.toggleVisibilityListener(true);
  },
  beforeDestroy() {
    this.toggleVisibilityListener();
  },
};
</script>
